import { render } from "./stepAllegatiIn.vue?vue&type=template&id=46908be0&ts=true"
import script from "./stepAllegatiIn.vue?vue&type=script&lang=ts"
export * from "./stepAllegatiIn.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__